import { Pagination } from "@/modules/common/types/Pagination";
import api from "../api";
import { CreateAdminUserDto, ListAdminUsersDto, UpdateAdminUserDto } from "../dto/admin-users";
import { AdminUserResponse, AdminUsersTotalizersResponse } from "../response/admin-users";

export const ADMIN_USERS_ENDPOINTS = {
  GET_TOTALIZERS: "/v1/admin/users/totalizers",
  GET_USERS: "/v1/admin/users",
  CREATE_USER: "/v1/admin/users",
  GET_USER: (id: string) => `/v1/admin/users/${id}`,
  UPDATE_USER: (id: string) => `/v1/admin/users/${id}`,
};

export const AdminUsersService = {
  getTotalizers: async (): Promise<AdminUsersTotalizersResponse> => {
    const response = await api.get(ADMIN_USERS_ENDPOINTS.GET_TOTALIZERS);
    return response.data;
  },

  getUsers: async (params?: ListAdminUsersDto): Promise<Pagination<AdminUserResponse>> => {
    const response = await api.get(ADMIN_USERS_ENDPOINTS.GET_USERS, { params });
    return response.data;
  },

  getUser: async (id: string): Promise<AdminUserResponse> => {
    const response = await api.get(ADMIN_USERS_ENDPOINTS.GET_USER(id));
    return response.data;
  },

  createUser: async (data: CreateAdminUserDto): Promise<AdminUserResponse> => {
    const response = await api.post(ADMIN_USERS_ENDPOINTS.CREATE_USER, data);
    return response.data;
  },

  updateUser: async (id: string, data: UpdateAdminUserDto): Promise<AdminUserResponse> => {
    const response = await api.put(ADMIN_USERS_ENDPOINTS.UPDATE_USER(id), data);
    return response.data;
  },
};
